export default "__VITE_ASSET__DGW2Mnuc__"